import React, { FC } from "react";
import Gutter from "ui-kit/Gutter";
import { Container } from "ui-kit/Layout";
import { FlexRow } from "ui-kit/Layout/Flex";
import Switch from "ui-kit/Switch/Switch";
import { Typography } from "ui-kit/Typography";

type LiabilityAddonProps = {
  onPress: () => void;
  active: boolean;
  title: string;
  description: string;
  first?: boolean;
  last?: boolean;
};

const LiabilityAddon: FC<LiabilityAddonProps> = ({
  onPress,
  active,
  title,
  description,
  first,
  last,
}) => {
  const style = {
    borderRadius: first || last ? undefined : 0,
    borderTopLeftRadius: first ? undefined : 0,
    borderTopRightRadius: first ? undefined : 0,
    borderBottomRightRadius: last ? undefined : 0,
    borderBottomLeftRadius: last ? undefined : 0,
    borderTop: first || last ? undefined : 0,
    borderBottom: first || last ? undefined : 0,
  };
  return (
    <Container border style={style}>
      <div style={{ cursor: "pointer" }} onClick={onPress}>
        <FlexRow justifyContent="space-between" alignItems="center">
          <div>
            <Typography variant="h4" color="grey500">
              {title}
            </Typography>
          </div>
          <Gutter size={1} horizontal />
          <Switch active={active} activeColor="blue300" />
        </FlexRow>
        <Gutter size={1} />
        <Typography variant="body3" color="grey500">
          {description}
        </Typography>
      </div>
    </Container>
  );
};

export default LiabilityAddon;
